import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Client from 'shopify-buy';
import './css/app.css';

const client = Client.buildClient({
  storefrontAccessToken: '849b4c0b3b6fc4f0d3586b9446ffbc43',
  domain: 'hellomadeshop.com'
});


ReactDOM.render(
  <App client={client}></App>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js